<script>
    import { ContentLoader } from "vue-content-loader"

    export default {
        components: { ContentLoader }
    }
</script>

<template>
    <content-loader
        :width="375"
        :height="688"
        :speed="2"
        primaryColor="#f3f3f3"
        secondaryColor="#ecebeb"
    >
        <rect x="307" y="29" rx="0" ry="0" width="1" height="1" />
        <rect x="0" y="2" rx="0" ry="0" width="375" height="211" />
        <rect x="15" y="259" rx="0" ry="0" width="339" height="20" />
        <rect x="15" y="285" rx="0" ry="0" width="136" height="20" />
        <rect x="22" y="338" rx="0" ry="0" width="30" height="30" />
        <rect x="90" y="338" rx="0" ry="0" width="30" height="30" />
        <rect x="162" y="338" rx="0" ry="0" width="30" height="30" />
        <rect x="234" y="338" rx="0" ry="0" width="30" height="30" />
        <rect x="313" y="338" rx="0" ry="0" width="30" height="30" />
    </content-loader>
</template>


// WEBPACK FOOTER //
// src/skeleton/shortVideoDetailSkeleton.vue